import React from 'react';
import { setCurrentView } from 'core/utils';
import { UpdateBuyShippingViewStore } from 'modules/order/stores';
import { UpdateBuyShippingTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new UpdateBuyShippingViewStore(rootStore, componentProps),
	'updateBuyShippingViewStore'
)
class UpdateBuyShipping extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <UpdateBuyShippingTemplate {...this.props} />;
	}
}

export default UpdateBuyShipping;



// WEBPACK FOOTER //
// ./src/modules/order/pages/UpdateBuyShipping.jsx